// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","CloseButton":"_31oPvn","fadeInFrames":"_1jnmJi"};